import React from 'react';
import { FormModal, FormField } from '../../../components/ui/Modal';
import { useAddColorModal } from './AddColorModal.hooks';

interface AddColorModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: { nombre: string; descripcion: string }) => Promise<void>;
}

const AddColorModal: React.FC<AddColorModalProps> = ({ isOpen, onClose, onSave }) => {
  const { formData, loading, error, handleFormChange, handleSave, handleClose } =
    useAddColorModal();

  const fields: FormField[] = [
    {
      name: 'nombre',
      label: 'Nombre',
      type: 'text',
      placeholder: 'Ej. Dorado',
      required: true,
    },
    {
      name: 'descripcion',
      label: 'Descripción',
      type: 'textarea',
      placeholder: 'Descripción del color...',
      rows: 3,
    },
  ];

  const handleSaveClick = async () => {
    await handleSave(onSave);
  };

  const formDataRecord: Record<string, string> = {
    nombre: formData.nombre || '',
    descripcion: formData.descripcion || '',
  };

  return (
    <FormModal
      open={isOpen}
      onClose={() => handleClose(onClose)}
      title="Agregar Color"
      fields={fields}
      formData={formDataRecord}
      onFieldChange={handleFormChange}
      onSave={handleSaveClick}
      loading={loading}
      error={error}
      saveButtonText="Guardar"
      cancelButtonText="Cancelar"
      maxWidth="sm"
      variant="simple"
    />
  );
};

export default AddColorModal;
